import { Component, Input, OnInit } from '@angular/core';
import { NavigationExtras, Router } from '@angular/router';
import { Truck } from 'src/app/models/truck';

@Component({
  selector: 'app-truck-card-found',
  templateUrl: './truck-card-found.component.html',
  styleUrls: ['./truck-card-found.component.scss'],
})
export class TruckCardFoundComponent implements OnInit {

  @Input() truck: Truck;

  constructor(
    private router: Router
  ) { }

  ngOnInit() {}

  jumpToTruckDetail() {
    const navigationExtras: NavigationExtras = { state: { truck: this.truck }};
    
    this.router.navigate(['trucks/truck-detail'], navigationExtras);
  }

}
